import React from 'react';
import b_ from 'b_';

import {UserPic} from 'client/common/components/lego';
import cfg from 'client/common/utils/client-config';
import {getStaffAvatarUrl, getStaffUrl, isStaffEmail} from 'client/common/utils/yandex-team';
import {UserAvatar} from 'client/common/types';

import './user-image.css';

const b = b_.with('user-image');

interface UserImageProps {
    email: string;
    login: string;
    avatar?: UserAvatar;
    text?: string;
}

export function UserImage(props: UserImageProps) {
    const {email, login, avatar, text} = props;

    const isYandexoid = isStaffEmail(email);

    return isYandexoid ? (
        <a
            className={b('link')}
            href={getStaffUrl(login)}
            target='_blank'
            rel='noopener noreferrer'
        >
            <img className={b('img')} src={getStaffAvatarUrl(login)} />
            {text && <span className={b('text')}>{text}</span>}
        </a>
    ) : (
        <div className={b('link')}>
            <UserPic className={b('img')} host={cfg.avatarsHost} avatarId={avatar?.default} />
            {text && <span className={b('text')}>{text}</span>}
        </div>
    );
}
